import React from 'react';
import PropTypes from 'prop-types';

import Link from 'components/Link';
import TeasePicture from 'components/TeasePicture';
import TypeIcon from 'components/TypeIcon';

import { hasTeaseImage } from 'lib/teaseUtils';

import AIMS_FLAVORS from 'lib/aimsFlavors';

const block = 'big-headline-tease';

const BigHeadlineTease = ({ teaseItem }) => {
  const { computedValues = {} } = teaseItem;

  if (!hasTeaseImage(computedValues)) {
    return null;
  }

  const { url } = computedValues;

  const teaseResponsiveFlavors = {
    s: AIMS_FLAVORS.FOCAL_758x379,
    m: AIMS_FLAVORS.FOCAL_920x460,
    l: AIMS_FLAVORS.FOCAL_600x300,
    xl: AIMS_FLAVORS.FOCAL_920x460,
  };

  return (
    <div className={`${block} relative mt0 mb0 mt7-m mb7-m mb0-l mt0-l w-100`}>
      <Link to={url} className="db">
        <TeasePicture
          responsiveFlavors={teaseResponsiveFlavors}
          type={teaseItem.type}
          computedValues={computedValues}
          className="big-headline-tease__picture"
        />
        <TypeIcon type={teaseItem.type} className="big-headline-tease__play-btn f2" />
      </Link>
    </div>
  );
};

BigHeadlineTease.propTypes = {
  teaseItem: PropTypes.objectOf(PropTypes.any).isRequired,
};

export { BigHeadlineTease };
